import Layout from "../Layout/Layout";
import Display from "../components/Display";

export default function HomePage() {
  return (
    <Layout>
      <Display />
    </Layout>
  );
}
